import { styled } from '@tools/wr-catalog-base'

export const DownloadButtonWrapper = styled.div`
  padding: 16px 0 16px 70px;
  background-color: #d7d7d7;
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
`

export const TableContainer = styled.div`
  margin-bottom: 30px;

  table {
    border-top: 0;
  }

  thead {
    tr {
      border-top: 0;
    }
  }

  th {
    background-color: #f2f2f2;
    border-top: 0;
    border-bottom: 1px solid #000;

    &:first-child {
      background-color: #d7d7d7;
      border-left: 1px solid #000;

      .overflow-wrapper {
        overflow: visible;

        .tooltip-container {
          white-space: nowrap;
        }
      }
    }

    &:last-child {
      border-right: 1px solid #000;
    }
  }

  td {
    border-bottom: 1px solid #000;

    &:first-child {
      background-color: #d7d7d7;
      border-right: none;
      border-left: 1px solid #000;
    }
  }

  .documents-table path {
    fill: ${({ theme }) => theme.palette.primary};
  }
`
